<template>
    <v-row justify="center">
        <v-dialog
            v-model="dialog"
            :persistent='true'
            width="48%"
            height="100%"
            class="modalDialog"
            no-click-animation
            >
            <div class="memberAdd">
                <v-card class="cardWrap">
                    <CardTitle title="予約変更設定画面" />
                    <v-container>
                        <v-row justify="center">
                            <v-col cols="2" class="inputTitle">
                                会員区分
                            </v-col>
                            <v-col cols="4">
                                {{ memberClassName }}
                            </v-col>
                            <v-col cols="2">
                            </v-col>
                        </v-row>
                        <v-form ref="form" onsubmit="return false;">
                            <v-row justify="center">
                                <v-col cols="2" class="inputTitle">
                                    プレー日
                                </v-col>
                                <v-col cols="4">
                                    <!--
                                    # 注意事項

                                    以下の年月日の入力項目では、入力形式を YYYY-MM-DD としており、数字入力時にハイフンが自動で補完されるようになっている。
                                    （keyup イベント時に formatDate 関数を呼び出しそれを行っている）

                                    しかし、IMEが全角モードで数字を入力すると、上記の補完がうまく動作せず、入力した数字が二重で入ってしまう。
                                    例）2021と入力すると、2021-20-21と入ってしまう。

                                    この現象の回避策として、type に tel を指定することで、IMEモードがOFFになり、半角でのみ入力できるようにする。

                                    なお、この年月日は手入力のみ許可するため、type に date は指定していない。
                                    （date を指定するとカレンダーが表示されてしまう）
                                    -->
                                    <v-menu
                                        ref="menu"
                                        v-model="menu"
                                        :close-on-content-click="false"
                                        transition="scale-transition"
                                        offset-y min-width="290px"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                inputmode="tel"
                                                type="tel"
                                                maxlength="10"
                                                placeholder="0000-00-00"
                                                v-on="on"
                                                v-model="formatedPlayDate"
                                                @focus="focusDate(passTo.playDate)"
                                                @keyup.delete="deleteKeyUp($event)"
                                                @keyup="passTo.playDate = formatDate(passTo.playDate)"
                                                @keydown.tab.exact="menu = false"
                                                :rules="[
                                                    rules.required,
                                                    rules.string_type,
                                                    rules.format_date,
                                                    rules.correct_date
                                                ]"
                                            />
                                        </template>
                                        <v-date-picker
                                            ref="picker"
                                            v-model="passTo.playDate"
                                            locale="jp-ja"
                                            :day-format="date => new Date(date).getDate()"
                                            min="1900-01-01"
                                            @input="menu = false"
                                        />
                                    </v-menu>
                                </v-col>
                                <v-col cols="2" class="inputTitle">
                                    <v-btn v-if="reserveType===3"
                                        color="primary"
                                        :disabled="passTo.planId == 0"
                                        @click="timeDialogOpen(received)">枠選択</v-btn>
                                    <v-btn v-else
                                        color="primary"
                                        :disabled="passTo.planId == 0"
                                        @click="displaySelectPlanList">プラン・枠選択</v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                        <v-row justify="center">
                            <v-col cols="2" class="inputTitle">
                                プラン
                            </v-col>
                            <v-col cols="6">
                                {{ planName }}
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-spacer></v-spacer>
                            <v-spacer></v-spacer>
                            <v-col cols="2">
                                <v-btn text color="primary" @click="CloseModal">閉じる</v-btn>
                            </v-col>
                            <!-- <v-col cols="2">
                                <v-btn text color="primary" @click="displayCellNumberDialog" :disabled="reserveType != 1">組数選択</v-btn>
                            </v-col>
                            <v-col cols="2">
                                <v-btn text color="primary" @click="displayPlayerNumberDialog">人数選択</v-btn>
                            </v-col> -->
                            <!-- <v-col cols="2" v-if="displayCompanion">
                                <v-btn
                                    color="primary"
                                    text
                                    @click="displayCompanionDialog">同伴者登録</v-btn>
                            </v-col> -->
                        </v-row>
                    </v-container>
                </v-card>
                <SelectPlanList
                    :received="passTo"
                    :planDialog="planDialog"
                    @success="successCompanionOpen($event)"
                    @close="closePlanList"
                    ref="SelectPlanModal"
                />
                <SelectCellNumber
                    ref="SelectCellModal"
                    :cellNumberDialog="cellNumberDialog"
                    @open-delete-companion="deleteCellNumber($event)"
                    @open-update-cell="selectCellDialogOpen($event)"
                    @close="closeChild"
                />
                <SelectPlayerNumber
                    ref="SelectPlayerModal"
                    :playerNumberDialog="playerNumberDialog"
                    @open-companion="updatePlayerNumber($event)"
                    @num-only-update="closeNumberAndMe"
                    @close="closeChild"
                />
                <Companion
                    ref="CompanionDialogView"
                    @close-companion="CloseModal"
                    @add-start-time="selectCellDialogOpen($event)"
                    v-show="companionDialog"
                />
                <DeleteCompanion
                    ref="DeleteCompanionDialogView"
                    @close-companion="CloseModal"
                    v-show="deleteCompanionDialog"
                />
                <StartTimeSelect
                    ref="StartTimeModal"
                    :received="passTo"
                    :childDialog="timeDialog"
                    @success="successClose($event)"
                    @close="closeChild"
                />
                <ChangeVisited
                  ref="VisitedDialogView"
                  @close-companion="closeCompanionModal"
                />
            </div>
        </v-dialog>
    </v-row>
</template>

<script>
import CardTitle from '@/components/module/CardTitle';
import SelectPlanList from './SelectPlanList';
import Companion from './Companion';
import SelectPlayerNumber from './SelectPlayerNumber';
import SelectCellNumber from './SelectCellNumber';
import DeleteCompanion from './DeleteCompanion';
import StartTimeSelect from './StartTimeSelect';
import { GET_CODE_LIST } from '@/constants/codelist';
import validater from '../../../lib/validater';
import { utilityMixin } from '@/mixins/utility';
import ChangeVisited from './ChangeVisited';
import { GET_PLAN_MASTER } from '@/constants/plan';

export default {
    components: {
        CardTitle,
        Companion,
        SelectPlanList,
        SelectPlayerNumber,
        SelectCellNumber,
        DeleteCompanion,
        StartTimeSelect,
        ChangeVisited
    },
    mixins: [
        utilityMixin
    ],
    props: {
        received: Object
    },
    data () {
        return {
            dialog: false,
            changeOverlay: false,
            planDialog: false,
            timeDialog: false,
            companionDialog: false,
            deleteCompanionDialog: false,
            playerNumberDialog: false,
            cellNumberDialog: false,
            planName: '',
            process: {
                // 処理結果
                result: '',
                // 処理結果メッセージ
                resultText: ''
            },
            passTo: {
                planId: '',
                golfCode: '',
                reserveType: '',
                playDate: '',
                memberNo: '',
                memberClass: '0',
                reserveNo: '',
                cellIdList: []
            },
            plan: {
                plan_id: '',
                request_flag: '',
                request_approval: ''
            },
            cellIdList: [],
            planId: '',
            reserveType: 0,
            // 会員区分選択ボックス
            memberClassSelect: [{
                code: '0',
                code_name: 'ビジター'
            }],
            displayCompanion: true,
            rules: {
                required: value => !!value.length || this.$t('error.validation.required.any'),
                string_type: value => validater.checkDateStringType(value) || this.$t('error.validation.num'),
                format_date: value => validater.checkDateFormat(value) || this.$t('error.validation.date.Correct'),
                correct_date: value => validater.checkCorrectDate(value) || this.$t('error.validation.date.Correct')
            },
            visitedDialog: false,
            menu: false
        };
    },
    async created () {
        this.memberClassSelect = await this.getCodeList('display_member_class');
        if (this.received.cellId !== '0') {
            this.displayCompanion = true;
        } else {
            this.displayCompanion = false;
        }
    },
    computed: {
        formatedPlayDate: {
            get () {
                return this.passTo.playDate;
            },
            set (value) {
                value = this.addHyphen(value);
                this.passTo.playDate = value;
            }
        },
        memberClassName () {
            if (this.memberClassSelect) {
                const d = this.memberClassSelect.find(el => el.code === String(this.passTo.memberClass));
                return d.code_name;
            } else {
                return [];
            }
        }
    },
    methods: {
        /** --------------------------------------------
        * コードリスト取得
        * -------------------------------------------- */
        getCodeList (keyname) {
            return this.$apollo.query({
                query: GET_CODE_LIST,
                variables: {
                    code_key: keyname,
                    default_display: 0
                }
            }).then(res => {
                return res.data.GetCodeList.CodeList;
            });
        },
        /** ----------------------------------------------
         * プラン情報を取得
         * ---------------------------------------------- */
        getPlanMaster (planId) {
            return this.$apollo.query({
                query: GET_PLAN_MASTER,
                fetchPolicy: 'no-cache',
                variables: {
                    plan_id: planId
                }
            }).then(res => {
                const data = res.data.getPlanMaster;
                return data.request_flag;
            });
        },
        refreshPassTo () {
            this.planId = this.received.planId;
            this.golfCode = this.received.golfCode;
            this.planName = this.received.planName;
            this.passTo.playerMin = this.received.playerMin;
            this.passTo.playerMax = this.received.playerMax;
            this.reserveType = this.received.reserveType;
            this.passTo.playerLeft = this.received.playerLeft;
            this.passTo.groupNum = this.received.groupNum;
            this.passTo.cellId = this.received.cellId;
            this.passTo.planId = this.received.planId;
            this.passTo.planName = this.received.planName;
            this.passTo.reserveType = this.received.reserveType;
            this.passTo.golfCode = this.received.golfCode;
            this.passTo.reserveNo = this.received.reserveNo;
            this.passTo.playDate = this.received.playDate;
            this.passTo.memberNo = this.received.memberNo;
            this.passTo.reserveType = this.received.reserveType;
            this.passTo.memberClass = this.received.memberClass;
            this.cellIdList.push({ cellId: this.received.cellId, number: this.received.playNumber });
        },
        ModalControl (reserveNo) {
            this.reserveNo = reserveNo;
            this.refreshPassTo();
            this.dialog = true;
        },
        async displaySelectPlanList () {
            if (this.$refs.form.validate()) {
                await this.$refs.SelectPlanModal.ModalControl(this.received.groupInfo);
                this.planDialog = true;
            }
        },
        displayPlayerNumberDialog (data) {
            this.$refs.SelectPlayerModal.ModalControl(this.received.reserveNo,
                this.received.playNumber,
                this.received.groupNum,
                this.passTo.playerMin,
                this.passTo.reserveType,
                this.passTo.playerLeft,
                this.passTo.playerMax,
                this.passTo.cellId);
            this.playerNumberDialog = true;
        },
        displayCellNumberDialog (data) {
            this.$refs.SelectCellModal.ModalControl(this.received.reserveNo,
                this.received.playNumber,
                this.received.groupNum,
                this.passTo.playerMin,
                this.passTo.reserveType,
                this.passTo.playerLeft,
                this.passTo.playerMax,
                this.passTo.cellId);
            this.cellNumberDialog = true;
        },
        /** ----------------------------------------------
         * 枠選択画面を表示する
         * ---------------------------------------------- */
        selectCellDialogOpen (info) {
            this.companionDialog = false;
            this.timeDialog = true;
            this.playerNumberDialog = false;
            this.$refs.StartTimeModal.ModalControl(this.received.planId, this.received.playDate, this.received.reserveType, this.received.groupInfo, this.received.planId);
        },
        /** ----------------------------------------------
         * 人数選択画面を表示する
         * ---------------------------------------------- */
        async timeDialogOpen (item) {
            const planId = item.planId;
            let reserveType = item.reserveType;
            const planReserveType = await this.getPlanMaster(planId);
            if (planReserveType === '0') {
                reserveType = 1;
            } else {
                reserveType = 3;
            }
            this.passTo.planId = planId;
            this.planId = planId;
            this.passTo.reserveType = reserveType;
            this.passTo.reserveNo = item.reserveNo;
            this.passTo.cellIdList.push({ cellId: item.cell_id, number: item.play_number });
            this.timeDialog = true;
            if (this.received.groupInfo) {
                this.$refs.StartTimeModal.ModalControl(this.planId, this.passTo.playDate, reserveType, this.received.groupInfo, null);
            } else {
                this.$refs.StartTimeModal.ModalControl(this.planId, this.passTo.playDate, reserveType, null, null);
            }
        },
        closePlanList () {
            this.planDialog = false;
        },
        /** ----------------------------------------------
         * 日付フォーマット処理
         * ---------------------------------------------- */
        deleteKeyUp (event) {
            this.passTo.playDate = this.formatDate(this.passTo.playDate);
            this.passTo.playDate = this.deleteKeyDelete(event);
        },
        /** ----------------------------------------------
         * 同伴者登録画面を表示する
         * ---------------------------------------------- */
        displayCompanionDialog () {
            if (this.companionDialog) return;
            this.companionDialog = true;
            this.$refs.CompanionDialogView.OpenDialog(this.received.reserveNo, false, this.received.planId);
        },
        /** ----------------------------------------------
         * 人数選択画面で正常終了したときに
         * 同伴者登録画面を表示する処理
         * ---------------------------------------------- */
        async successCompanionOpen (reserveNo) {
            await this.$refs.CompanionDialogView.OpenDialog(reserveNo, false, this.received.planId, 'changeCompanion');
            this.planDialog = false;
        },
        /** ----------------------------------------------
         * 人数選択画面を表示する
         * ---------------------------------------------- */
        updatePlayerNumber (reserveNo) {
            this.$refs.CompanionDialogView.OpenDialog(reserveNo, false, this.received.planId);
            this.playerNumberDialog = false;
        },
        /** ----------------------------------------------
         * 同伴者画面（組削除）を表示する
         * ---------------------------------------------- */
        deleteCellNumber (info) {
            if (this.companionDialog) return;
            this.companionDialog = true;
            this.$refs.DeleteCompanionDialogView.OpenDialog(info.reserveNo, false, info.groupNum, this.received);
            this.cellNumberDialog = false;
            this.deleteCompanionDialog = true;
            this.playerNumberDialog = false;
        },
        /** ----------------------------------------------
         * 変更ダイアログを閉じる
         * ---------------------------------------------- */
        closeChild (item) {
            this.companionDialog = false;
            this.planDialog = false;
            this.playerNumberDialog = false;
            this.cellNumberDialog = false;
            this.timeDialog = false;
            if (item) {
                this.cellIdList = item.selectCellId;
            }
        },
        /** ----------------------------------------------
         * リクエスト予約でCellIdが0の時
         * 同伴者画面を表示せず画面を閉じる処理
         * ---------------------------------------------- */
        closeNumberAndMe () {
            this.closeChild();
            this.CloseModal();
        },
        /** ----------------------------------------------
         * モーダル画面を閉じる際の処理
         * ---------------------------------------------- */
        CloseModal () {
            this.cellIdList = [];
            this.dialog = false;
            this.companionDialog = false;
            this.$emit('refresh-event');
        },
        successClose (reserveNo) {
            this.timeDialog = false;
            this.openCompanionModal();
        },
        /** ----------------------------------------------
         * モーダル画面を閉じる際の処理
         * ---------------------------------------------- */
        changeDisplayCompanion (flag) {
            this.displayCompanion = flag;
        },
        openCompanionModal () {
            if (this.visitedDialog) return;
            this.visitedDialog = true;
            this.$refs.CompanionDialogView.OpenDialog(this.received.reserveNo, false, this.received.planId, 'changeCompanion');
        },
        closeCompanionModal () {
            this.visitedDialog = false;
            this.CloseModal();
        }
    }
};
</script>

<style scoped>

.inputTitle{
    align-self: center;
}

</style>
